<template>
  <div>
    <GainsComponent />
  </div>
</template>

<script>
import GainsComponent from './components/Index.vue'

export default {
  name: 'GainsIndex',
  components: {
    GainsComponent,
  }
}
</script>
